var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":_vm.customerName,"visible":_vm.visible,"width":"50%"},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('BusinessList',{attrs:{"customerId":_vm.customerId,"height":"400"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }